<template>
  <div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업기간</span></label>
      <div class="col-4 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          :value="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          @change="(val) => { permit.workPeriod = val; }"
          style="font-size: 12px;" input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>밀폐공간 형태</span></label>
      <div class="col-10 pt-2">
        <label class="md-check mr-20" v-for="t in confinedSpaceTypes" :key="t">
          <input type="checkbox" v-model="permit.spaceTypes" :value="t">
          <i class="blue"></i>{{ t }}
        </label>
        <label class="md-check mr-10">
          <input type="checkbox" v-model="permit.isOther">
          <i class="blue"></i>기타 밀폐공간
        </label>
        <input v-if="permit.isOther" type="text" class="form-control mt-5"
               v-model="permit.otherText" placeholder="기타 밀폐공간 내용 입력 (필수)"
               :style="{ maxWidth:'300px', ...((permit.otherText || '').trim() ? {} : { borderColor:'#eb5757' }) }">
        <div v-if="permit.isOther && !(permit.otherText || '').trim()"
             style="color:#eb5757; font-size:11px; margin-top:4px;">기타 밀폐공간 내용은 필수 입력입니다.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfinedSpacePermit',
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      confinedSpaceTypes: ['맨홀 내부', '수조 내부', '축열조 내부', '급탕저장소·가습순환조 내부', '소화가스실', '집수정 내부', '경유·옥내·지하저장탱크 내부']
    }
  }
}
</script>